type SizeType = 'xs' | 'sm' | 'md' | 'lg';
type ColorType = 'blue' | 'red' | 'green';

interface LoadingProps {
  size: SizeType;
  color: ColorType;
  isVisible: boolean;
}

const Loading = ({ size, color, isVisible }: LoadingProps) => {
  if (!isVisible) return null;

  const sizeStyles = {
    xs: 'w-4 h-4 border-2',
    sm: 'w-6 h-6 border-2',
    md: 'w-16 h-16 border-4',
    lg: 'w-24 h-24 border-6'
  };

  const innerSizeStyles = {
    xs: 'w-4 h-4 border-2',
    sm: 'w-6 h-6 border-4',
    md: 'w-10 h-10 border-4',
    lg: 'w-18 h-18 border-6'
  };

  const colorStyles = {
    blue: 'border-blue-500 border-transparent',
    red: 'border-red-500 border-t-transparent',
    green: 'border-green-500 border-t-transparent'
  };

  const innerColorStyles = {
    blue: 'border-blue-500 border-t-transparent',
    red: 'border-red-500 border-t-transparent',
    green: 'border-green-500 border-t-transparent'
  };

  return (
    <div className="flex items-center justify-center h-full">
      <div className="relative">
        <div className={`${sizeStyles[size]} ${colorStyles[color]} rounded-full `}></div>
        <div className="absolute inset-0 flex items-center justify-center">
          <div className={`${innerSizeStyles[size]} ${innerColorStyles[color]} rounded-full animate-spin`}></div>
        </div>
      </div>
    </div>
  );
};

export default Loading;